<template>
  <div>
    <el-input
      type="textarea"
      v-model="state.remark"
      :autosize="{ minRows: 3 }"
    />
    <ul class="flex items-center">
      <el-button type="danger">不通过</el-button>
      <el-button type="success">通过</el-button>
    </ul>
    <strong>报名信息</strong>
    
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
